import { detect } from "detect-browser";

const browser = detect();
export const isIe = browser.name === "ie";
export const isEdge = browser.name === "edge";
export const isIeOrEdge = isIe || isEdge;
export const isNeitherIeNorEdge = !isIe && !isEdge;
